import * as rsuite from 'rsuite';
import { HiOutlineXCircle } from "react-icons/hi";

// The delete-confirmation modal shared by every CRUD list page.
const ConfirmDeleteModal = ({ open, message, onConfirm, onCancel }) => (
    <rsuite.Modal open={open} onClose={onCancel}>
        <rsuite.Modal.Body className="px-2">
            <p>{message}</p>
        </rsuite.Modal.Body>
        <rsuite.Modal.Footer>
            <rsuite.Button onClick={onConfirm} appearance="primary" color="red" startIcon={<HiOutlineXCircle className="me-1" />}>
                بله
            </rsuite.Button>
            <rsuite.Button onClick={onCancel} appearance="subtle">
                انصراف
            </rsuite.Button>
        </rsuite.Modal.Footer>
    </rsuite.Modal>
);

export default ConfirmDeleteModal;
